<div class="container-fluid mt-5">
    <div class="swiper-container p-0" [swiper]="projectConfig" [(index)]="index" style="padding: 30px;">
        <div class="swiper-wrapper p-0">
            <div class="swiper-slide p-0" *ngFor="let project of projects">
                <div class="row p-0">
                    <div class="col-12 align-self-center p-0">
                        <img [src]="project.imgUrl" class="img-fluid">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <img class="img-fluid mb-4" src="../../../../../assets/group.svg">
                        <h6 class="text-white mb-5">SERVICIOS APLICADOS EN LA PLATAFORMA</h6>
                        <!-- <button class="btn btn-sm btn-brand px-4 mt-3">IR AL ENLACE</button> -->

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>